"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capestrano": {
    "44dff298": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-frivello": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ee5e29f": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "skipSearch": false
    }],
    "collelungo": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8cc4d06f": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "skipSearch": false
    }],
    "forca-di-penne": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae556631": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "28ab959c",
      "slug": "capestrano",
      "name": "Capestrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;